export default __webpack_public_path__ + "static/media/Steam_Turbine_Piping.739eac5f.jpg";